export default __webpack_public_path__ + "static/media/nutrition-icon-grey.abbfa4e4.svg";